// Pixelbilder scharf auf den Bildschirm (Erste Fassung, Runde 7: nichts verzerrt oder unscharf skaliert): Eine Szene wird
// in ihrer Bildgröße gemalt (640 × 360) und dann in ganzzahliger Vergrößerung ohne Glätten auf die sichtbare Leinwand
// gesetzt, mindestens so groß wie die Leinwand auf dem Bildschirm. Den letzten Schritt auf die Größe im Fenster macht der
// Browser weich; so sind alle Bildpixel gleich breit, nur die Kanten sind einen Hauch weich.

/** Die Szene vergrößert auf die sichtbare Leinwand setzen */
export function presentScene(visible: HTMLCanvasElement, scene: HTMLCanvasElement): void {
  const css = visible.getBoundingClientRect().width || scene.width;
  const dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  const m = Math.max(1, Math.ceil((css * dpr) / scene.width - 1e-3));
  const w = scene.width * m;
  const h = scene.height * m;
  if (visible.width !== w || visible.height !== h) {
    visible.width = w;
    visible.height = h;
  }
  const ctx = visible.getContext('2d')!;
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(scene, 0, 0, w, h);
}

/** Eine Leinwand für die Szene in Bildgröße, je Name einmal */
const scenes = new Map<string, HTMLCanvasElement>();
export function sceneCanvas(name: string, w: number, h: number): HTMLCanvasElement {
  let c = scenes.get(name);
  if (!c) {
    c = document.createElement('canvas');
    scenes.set(name, c);
  }
  if (c.width !== w || c.height !== h) {
    c.width = w;
    c.height = h;
  }
  return c;
}
